<template>
  <div class="p-test-center">
    <button class="button--create" @click="onCreateClick"></button>
    <card-header>测评中心</card-header>
    <p class="p-test-center__subtitle mt-40">* 仅展示老师自己任教的年级、班级、学科信息</p>
    <div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属年级：</span>
        <div class="s-form-item__hidden" ref="AllGrade">
          <div ref="grade" style="position: relative;top: -12px;">
            <span :class="getClass('grade', '')" class="s-form-item__text pointer"
              @click="onChange('grade', '')"> 全部 </span>
            <span
            class="dot-span pointer"
            :class="getClass('grade', item.academic_year_id)"
            v-for="item in gradeList"
            :key="item.academic_year_id"
            @click="onChange('grade', item)"
          >{{item.name}}</span>
          </div>
        </div>
        <span class="s-form-item__label blue pointer" v-if="!unfoldGrade && unfoldGradeShow"
        @click="unfold('grade')"> 展开
          <i class="el-icon-caret-bottom"></i>
        </span>
        <span class="s-form-item__label blue pointer" v-if="!unfoldGrade && !unfoldGradeShow"
        @click="packUp('grade')"> 收起
          <i class="el-icon-caret-top"></i>
        </span>
      </div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属班级：</span>
        <div class="s-form-item__hidden" ref="AllClass">
          <div ref="class" style="position: relative;top: -12px;">
            <span :class="getClass('class', '')" class="s-form-item__text pointer"
            @click="onChange('class', '')"> 全部 </span>
            <span
              class="dot-span pointer"
              :class="getClass('class', item.id)"
              v-for="item in classList"
              :key="item.id"
              @click="onChange('class', item)"
            >{{item.name}}</span>
          </div>
        </div>
        <span class="s-form-item__label blue pointer" v-if="!unfoldClass && unfoldClassShow"
        @click="unfold('class')"> 展开
          <i class="el-icon-caret-bottom"></i>
        </span>
        <span class="s-form-item__label blue pointer" v-if="!unfoldClass && !unfoldClassShow"
        @click="packUp('class')"> 收起
          <i class="el-icon-caret-top"></i>
        </span>
      </div>
      <div class="s-form-item">
        <span class="s-form-item__label">所属学科：</span>
        <div style="position: relative; top: -12px">
            <span :class="getClass('subject', '')"
            class="s-form-item__text pointer" @click="onChange('subject', '')"> 全部 </span>
            <span
              class="dot-span pointer"
              :class="getClass('subject', item.id)"
              v-for="item in sortedSubjectList"
              :key="item.id"
              @click="onChange('subject', item)"
            >{{item.name}}</span>
        </div>
      </div>
    </div>
    <!-- 搜索 -->
    <div v-if="testList.length > 0 && searchForm.subject">
      <div class="s-form-item g-f-h-c">
        <span class="s-form-item__label">测试内容：</span>
        <el-select
          placeholder="版本"
          v-model="searchForm.version"
          class="c-select"
          value-key="id"
          clearable
        >
          <el-option
            v-for="item in versionList"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
          </el-select>
        <el-select
          placeholder="年级"
          v-model="searchForm.stage"
          class="ml-16 c-select"
          value-key="id"
          clearable
          >
            <el-option
            v-for="item in stageList"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          clearable
          placeholder="课程"
          v-model="searchForm.course"
          class="ml-16 c-select"
          value-key="id">
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- <img src="./images/search_tip.png" v-else alt="" class="search-tip"> -->
    <Empty v-if="gradeList.length < 1 && testList.length<1"
    content="暂未获取到您任教的年级、班级信息," lastContent="请联系校区管理员设置" :show="false" />
    <Empty v-if="gradeList.length>0 && subjectList.length < 1 && testList.length<1"
    content="暂无数据~," />
    <footer class="search-footer" v-if="testList.length > 0">
      <span >在当前筛选条件下，共搜索到 {{total}} 条测评记录</span>
      <!-- <span v-else>当前搜索条件下没有找到任何测评，换个条件试试吧</span> -->
      <div>
        <el-input placeholder="请输入测评名称" clearable v-model="searchForm.testName"></el-input>
        <el-button type="primary" @click="onSearchClick">查询</el-button>
      </div>
    </footer>
    <!-- table -->
    <div class="test-list">
      <test-panel
        v-for="item in testList"
        :type="true"
        :data="item"
        :key="item.batch_id"
        @reload="getEvaluateList" />
        <div class="test-empty" v-if="emptyShow && testList.length<1 && gradeList.length>0">
          <img src="./images/empty.png" alt="">
          <p class="empty-text">未找到任何测评, 清先创建测评</p>
          <button class="button-create" @click="onCreateClick"></button>
        </div>
        <Empty v-if="!emptyShow &&  testList.length<1 && subjectList.length>0 && gradeList.length>0"
        content="当前搜索条件下没有找到任何测评,"
        lastContent="换个条件试试吧" />
    </div>
    <!-- 分页 -->
    <el-pagination
      v-if="testList.length"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-size.sync="pageSize"
      :page-sizes="[10, 50, 100]"
      :current-page.sync="currentPage"
    >
    </el-pagination>
  </div>
</template>

<script>
import CardHeader from '@/components/card-header.vue';
import { getEvaluateList, getTeacherClass, getTeacherYear } from '@/api/pt';
import { getSign } from '@/utils/verify';
import mixins from './mixins';
import TestPanel from './components/test-panel.vue';
import Empty from '@/views/pt/components/empty.vue';

const ascending = 1;
const descending = 0;
const TEACHER_ROLE = 6008003;
// const TOB = 1; // 渠道 1 tob 2运营平台

const EVALUATE_OR_PREVIEW = 1; // 1为测评 2为预习
export default {
  components: {
    CardHeader,
    TestPanel,
    Empty,
  },
  name: 'TestCenter',
  mixins: [mixins],
  data() {
    const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
    return {
      searchForm: {
        grade: '',
        subject: '',
        class: '',
        version: '',
        stage: '',
        course: '',
        testName: '',
        sortBy: 'created',
        order: descending,
      },
      total: 0, // 总数
      pageSize: 10,
      currentPage: 1,
      // 测试内容年级（阶段）列表
      stageList: [],
      // 可选科目
      subjectList: [],
      // 可选版本
      versionList: [],
      // 可选年级
      gradeList: [],
      // 可选班级
      classList: [],
      // 可选课程
      courseList: [],
      // 测评列表
      testList: [],
      unfoldGradeShow: true,
      unfoldClassShow: true,
      unfoldClass: false,
      unfoldGrade: false,
      emptyShow: false,
      isTeacher: userInfo.position === TEACHER_ROLE,
      isEvaluate: EVALUATE_OR_PREVIEW,
    };
  },
  mounted() {
  },
  computed: {
    visibleTestSearch() {
      return !!this.searchForm.subject;
    },
    sortedSubjectList() {
      if (!this.subjectList || !this.subjectList.length) {
        return [];
      }
      return this.subjectList.map((item) => item).sort((a, b) => a.id - b.id);
    },
  },
  watch: {
    gradeList() {
      this.$nextTick(() => {
        console.log(this.$refs.grade.offsetHeight, 66);
        if (this.$refs.grade && this.$refs.grade.offsetHeight < 70) {
          console.log(3);
          this.unfoldGrade = true;
        } else {
          console.log(4);
          this.unfoldGrade = false;
        }
      });
    },
    classList() {
      this.$nextTick(() => {
        if (this.$refs.class && this.$refs.class.offsetHeight < 70) {
          this.unfoldClass = true;
        } else {
          this.unfoldClass = false;
        }
      });
    },
    currentPage() {
      this.getEvaluateList();
    },
    pageSize() {
      this.getEvaluateList();
    },
    'searchForm.grade': {
      immediate: true,
      handler(v) {
        getTeacherClass({
          id: (v && v.academic_year_id) || '',
        }).then((res) => {
          if (res.code === 200) {
            this.classList = res.data;
          }
        });
      },
    },
    searchForm: {
      deep: true,
      handler() {
        this.getEvaluateList();
      },
    },
  },
  activated() {
    this.initData();
    this.getEvaluateList();
  },
  methods: {
    unfold(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = false;
        this.$refs.AllGrade.style.height = `${this.$refs.grade.offsetHeight}px`;
      }
      if (type === 'class') {
        console.log(this.$refs.class.offsetHeight);
        this.unfoldClassShow = false;
        this.$refs.AllClass.style.height = `${this.$refs.class.offsetHeight}px`;
      }
    },
    packUp(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = true;
        this.$refs.AllGrade.style.height = '42px';
      }
      if (type === 'class') {
        this.unfoldClassShow = true;
        this.$refs.AllClass.style.height = '42px';
      }
    },
    getMasterClass(value) {
      // <!-- 【0，40）红色，【40，70）橙色，【70，100】绿色 -->
      if (value >= 70) {
        return 't--green';
      }
      if (value >= 40) {
        return 't--orange';
      }
      return 't--red';
    },
    onCreateClick() {
      this.$router.push({
        path: '/pt/create-test',
        query: {
          from: 'test-center',
        },
      });
    },
    onSortChange(item) {
      // 无序默认按时间倒序
      if (!item.order) {
        this.searchForm.order = descending;
      } else {
        this.searchForm.sortBy = item.prop;
        this.searchForm.order = item.order === 'ascending' ? ascending : descending;
      }
      if (this.currentPage === 1) {
        this.getEvaluateList();
      } else {
        this.currentPage = 1;
      }
    },
    onSizeChange(v) {
      this.pageSize = v;
      if (this.currentPage === 1) {
        this.getEvaluateList();
      } else {
        this.currentPage = 1;
      }
    },
    initData() {
      // 年级、班级
      getTeacherYear().then((res) => {
        if (res.code === 200) {
          this.gradeList = res.data;
        }
      });
      // 选课列表
      const typeList = ['subjects'];
      typeList.forEach((type) => {
        this.getCategory({ type, ...this.searchForm[type] });
      });
    },
    onDetailClick(row) {
      this.$router.push({
        path: '/pt/class-report',
        query: {
          evaluateId: row.evaluate_id,
          schoolId: row.school_id,
          classId: row.class_id,
        },
      });
    },
    isCurrent(type, value) {
      if (!this.searchForm[type]) {
        return !value;
      }
      if (type === 'grade') {
        return this.searchForm.grade.academic_year_id === value;
      }
      return this.searchForm[type].id === value;
    },
    getClass(type, value) {
      return this.isCurrent(type, value) ? 'is-blue' : '';
    },
    onChange(type, item) {
      this.searchForm[type] = item;
    },
    onSearchClick() {
      this.getEvaluateList();
    },
    getEvaluateList() {
      // this.emptyShow = false;
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const data = {
        // re_from: TOB,
        school_id: userInfo.campusId,
        type: this.isEvaluate,
        teacher_id: userInfo.id,
        role_id: userInfo.position,
        school_year: this.searchForm.grade.name || '',
        grade_id: this.searchForm.grade.id || '',
        class_id: this.searchForm.class.id || '',
        evaluate_name: this.searchForm.testName || '',
        subject_id: this.searchForm.subject.id || '',
        textbook_id: this.searchForm.version.id || '',
        test_grade_id: this.searchForm.stage.id || '',
        test_id: this.searchForm.course.id || '',
        page_size: this.pageSize,
        curr_page: this.currentPage,
        sort: this.searchForm.order,
      };
      return getEvaluateList({
        ...data,
        sign: getSign(data),
      }).then((res) => {
        if (res.code === 200) {
          this.testList = res.data.list;
          this.total = res.data.total;
        }
        if (data.class_id === ''
          && data.subject_id === ''
          && this.testList.length < 1) {
          this.emptyShow = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.p-test-center {
  padding: 32px 32px 100px;
  min-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  &__subtitle {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
  }
  .empty-img {
    width: 160px;
  }
  .test-list {
    margin-top: 38px;
    min-height: 500px;
    .test-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #C0C4CC;
      font-size: 16px;
      img {
        width: 200px;
        margin-bottom: 20px;
      }
    }
  }
  .button--create {
    width: 121px;
    height: 40px;
    background-image: url('~@/views/pt/images/button_create.png');
    background-size: 100% 100%;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 2;
  }
  .button-create {
    width: 121px;
    height: 40px;
    margin-top: 10px;
    background-image: url('~@/views/pt/images/button_create.png');
    background-size: 100% 100%;
  }
  .search-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    .el-button {
      border-radius: 0 4px 4px 0;
    }
    .el-input {
      width: 328px;
      vertical-align: bottom;
      /deep/ .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
  }
  .s-lg {
    width: 120px;
    height: 40px;
  }
  /deep/ .el-form-item__label {
    font-size: 16px;
    font-weight: 500;
  }
  /deep/ .el-table th {
    background: rgba(240, 242, 245, 1);
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    font-weight: 500;
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    width: calc(100% - 64px);
    bottom: 30px;
    left: 32px;
    .btn-prev {
      margin-left: auto;
    }
  }
  .search-tip {
    display: block;
    margin: -10px 0 0;
    width: 434px;
  }
  .s-form-item {
    line-height: 42px;
    font-size: 14px;
    display: flex;
    padding: 20px 0;
    &:not(:last-of-type) {
      border-bottom: 1px dashed rgba(220, 225, 235, 1);
    }
    &__text {
      margin-right: 30px;
      line-height: 24px;
      padding: 7px 12px;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
    &__hidden {
      overflow: hidden;
      height: 42px;
    }
    &__label {
      color: rgba(0, 0, 0, 1);
      font-weight: 400;
      font-size: 16px;
      width: 104px;
      min-width: 104px;
    }
    .blue {
      color: rgba(25, 137, 250, 1);
    }
    .is-blue {
      border-radius: 5px;
      background-color: rgba(25, 137, 250, 1);
      color: #fff;
      font-weight: 500;
      &:hover {
        color: #fff !important;
      }
    }
    .dot-span {
      padding: 7px 12px;
      box-sizing: border-box;
      // padding-left: 20px;
      display: inline-block;
      line-height: 24px;
      position: relative;
      margin-right: 30px;
      margin-top: 16px;
      white-space: nowrap;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
  }
}
</style>
